import { render, staticRenderFns } from "./CompetitionTypes.page.vue?vue&type=template&id=22de1ff9"
import script from "./CompetitionTypes.page.vue?vue&type=script&lang=ts"
export * from "./CompetitionTypes.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.44_cache-loader@4.1.0_webpack@4.47.0__css-load_9104b087796de0a589f26e8ae34b49bc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports